import { berechnung } from './client'

import { createClient } from '@hey-api/client-fetch'
import { useTextStore } from './stores/texts'

export const gavClient = createClient({
  baseUrl: import.meta.env.VITE_GAV_API_HOST
})

export const client = createClient({
  baseUrl: import.meta.env.VITE_API_HOST,
  credentials: 'include'
})

export const modelClient = createClient({
  baseUrl: import.meta.env.VITE_MODEL_API_HOST,
  credentials: 'include'
})

export function setupClients() {
  const textStore = useTextStore()

  client.interceptors.request.use((request) => {
    request.headers.set('Accept-Language', textStore.language)
    return request
  })
}

// Das Modell lehnt Profile, für die es keine Prognose gibt, mit HTTP 400 und
// { error: '...' } ab (unbekannte Berufsgruppe, zu wenige Beobachtungen).
// Feldfehler kommen dagegen als { feld: ['...'] }.
export function declineReason(error) {
  if (!error || typeof error !== 'object') return null
  return typeof error.error === 'string' ? error.error : null
}

// Das Modell rechnet neu auf der Berufsuntergruppe (3-stellige ISCO). `subgroup`
// wird als null serialisiert, falls sie einmal fehlt — dann die Berufsgruppe zeigen.
export function occupationGroupName(request) {
  return request?.subgroup?.name || request?.group?.name
}

export async function submitLohnrechner(store, resultStore) {
  if (store.branche == null) {
    resultStore.state = 'stale'
    return
  }
  resultStore.state = 'loading'
  resultStore.errors = {}
  resultStore.errorMessage = null

  let request = {
    beruf: store.beruf,
    branche: store.branche,
    age: store.age,
    experience: Math.min(store.experience, store.age - 18),
    position: store.stellung,
    education: store.ausbildung,
    plz: store.onrp,
    stunden: store.stunden,
    first_name: store.contact.first_name,
    last_name: store.contact.last_name,
    email: store.contact.email
  }

  let response = await berechnung({ body: request, client: client })

  if (response.error) {
    const declined = declineReason(response.error)
    if (declined) {
      resultStore.state = 'unavailable'
      resultStore.errorMessage = declined
      return resultStore.state
    }
    resultStore.state = 'error'
    Object.keys(response.error).forEach((key) => {
      const messages = response.error[key]
      resultStore.errors[key] = Array.isArray(messages) ? messages[0] : messages
    })
    return
  }
  let data = response.data

  resultStore.result['p25'] = data.quantiles[0]
  resultStore.result['p50'] = data.quantiles[1]
  resultStore.result['p75'] = data.quantiles[2]
  resultStore.result.is_national = data.is_national

  Object.assign(resultStore.request, data.request)
  resultStore.state = 'done'

  return resultStore.state
}

export async function getResult(profil, beruf) {
  let request = {
    beruf: beruf.pk,
    branche: profil.branche.pk,
    age: profil.age,
    experience: profil.seniority,
    position: profil.position.pk,
    education: profil.education.pk,
    plz: profil.location.pk,
    stunden: +profil.stunden,
    src: 'job-site'
  }
  const response = await berechnung({ body: request, client: client })
  // 400 = Modell liefert für dieses Profil keine Prognose -> Widget wird ausgeblendet
  if (response.error) return null
  return response.data
}
